type Props = {
  title: string
}

export default function PageHeader({ title }: Props) {
  return (
    <div className="mb-6">
      <h1 className="text-3xl font-bold">{title}</h1>
    </div>
  )
}